document.addEventListener('DOMContentLoaded', function() {
    function equalizeColumnHeights() {
        const gallery = document.querySelector('.product-gallery');
        const info = document.querySelector('.product-info');
        if (info && gallery) {
            const smallerHeight =  info.scrollHeight;
            
            gallery.style.maxHeight = `${smallerHeight}px`;
            
        }
    }
    equalizeColumnHeights();

    // Run on page load and resize
    window.addEventListener('load', equalizeColumnHeights);
    window.addEventListener('resize', equalizeColumnHeights);
    
}); 